export default function download(fileDataType="application/json", dataString="", fileName="LobbyView.json"){
  const blob = new Blob([dataString], {type : fileDataType}); //create new blob
  const blobUrl = URL.createObjectURL(blob); //get data url from blob
  let a = document.createElement('a'); //create dummy anchor element
  a.setAttribute("href", blobUrl); //set the data to download
  a.setAttribute("download", fileName); //set the file name
  a.click(); //click to download file
  a.remove(); //removes anchor element
}
